import React from 'react';
type BookStackProps = {
  className?: string;
};
export function BookStack({
  className = ''
}: BookStackProps) {
  return <div className={`mx-auto w-full max-w-[860px] ${className}`} data-id="element-46" data-mp="2i959chcg0igs">
      <img src="https://cdn.magicpatterns.com/uploads/7EmD2AC3VDmoCZPKaiQwS4/Imagen_de_ChatGPT_27_sept_2026,_08_34_54_p.m..png" alt="Megapack Maestro de Sesiones: los 6 módulos en espiral junto al volumen principal del sistema" className="h-auto w-full mix-blend-multiply" width={1448} height={1086} data-id="element-47" data-mp="23m3o6457x7mw" />
    </div>;
}